import React from 'react';

const ReactFragment = (): React.JSX.Element => <></>;
export default ReactFragment;
